import {unescape} from 'lodash';
import {tranformItem} from 'cms/helpers/common';

const getCategories = (sidebar, id) => tranformItem(['ID', 'post_title', 'permanlink'])(sidebar)
  .map((category) => ({
    ...category,
    selected:  category.ID === id,
    post_title:  unescape(category.post_title)
  }));

export {getCategories};